import { Component } from '@angular/core';

@Component({
    selector: 'trigger-by-keyword',
    template: '<router-outlet></router-outlet>',
    standalone: false
})

export class TriggerByKeywordComponent {
}
